import React, { useEffect, useState } from 'react';
import identity from 'lodash/identity';
import BusyCover from '../BusyCover/BusyCover';
import { uniqueId } from 'lodash';
import Heading from '../Typography/Heading';
import FormError from './components/FormError';

import './Form.less';

/**
 *
 * @param {{
 * title?:React.ReactNode;
 * icon?:React.ReactElement;
 * name?:string;
 * isNarrow?:boolean;
 * noAutocomplete?:boolean;
 * isMedium?:boolean;
 * hasBorder?:boolean;
 * noSpacings?:boolean;
 * isButtonsStack?:boolean;
 * buttons?:React.ReactElement|React.ReactElement[]|(() => React.ReactElement|React.ReactElement[]);
 * children?:React.ReactNode|React.ReactNode[];
 * extraFooter?:React.ReactElement;
 * classNameForm?:string;
 * classNameTitle?:string;
 * classNameContent?:string;
 * classNameButtons?:string;
 * classNameExtraFooter?:string;
 * onSubmit?(e?:React.FormEvent):void;
 * onChange?(params:{isValid:boolean}):void;
 * formAttr?:React.FormHTMLAttributes<HTMLFormElement>;
 * isBusy?:boolean;
 * hidden?:boolean;
 * errors?:React.ReactNode|React.ReactNode[];
 * }} props
 * @returns
 */
export const From = (props) => {
  const {
    title,
    icon,
    name,
    hasBorder,
    isNarrow,
    isMedium,
    noSpacings,
    isBusy,
    hidden,
    children,
    buttons,
    extraFooter,
    noAutocomplete,
    isButtonsStack,
    classNameTitle,
    classNameForm,
    classNameContent,
    classNameButtons,
    classNameExtraFooter,
    errors,
    onSubmit,
    onChange,
    // direct attributes
    formAttr,
  } = props;

  const [formUID] = useState(uniqueId('lsn_form_'));
  const [formName] = useState(name ?? formUID);

  const classNames = [
    'lsn-form',
    hasBorder ? 'lsn-form-bordered' : '',
    isNarrow && !isMedium ? 'lsn-form-narrow' : '',
    isMedium ? 'lsn-form-medium' : '',
    isBusy ? 'lsn-form-busy' : '',
    noSpacings ? 'lsn-form-no-spacings' : '',
    classNameForm,
  ].filter(identity).join(' ');

  const classNamesTitle = [
    'form-title',
    classNameTitle
  ].filter(identity).join(' ');

  const classNamesContent = [
    'form-content',
    classNameContent
  ].filter(identity).join(' ');

  const classNamesButtons = [
    'form-buttons',
    isButtonsStack ? 'form-buttons-vertical' : '',
    classNameButtons,
  ].filter(identity).join(' ');

  const classNamesExtraFooter = [
    'form-extra-footer',
    classNameExtraFooter,
  ].filter(identity).join(' ');

  /**
   *
   * @param {React.FormEvent} e
   */
  const onSubmitProxy = (e) => {
    e?.preventDefault();
    const formElement = (/** @type {HTMLFormElement} */(document.forms[formName]));
    const isValid = formElement.checkValidity();
    if (isValid) {
      onSubmit?.(e);
    }
    return false;
  }

  const onChangeProxy = () => {
    setTimeout(() => {
      const formElement = (/** @type {HTMLFormElement} */(document.forms[formName]));
      const isValid = [...formElement?.querySelectorAll('input') ?? []].map(input => input.validity.valid).every(Boolean);
      onChange?.({ isValid });
    });
  }

  const getButtons = () => {
    return typeof buttons === 'function' ? buttons() : buttons;
  }

  // TODO: in-progress
  useEffect(() => {
    const formElement = (/** @type {HTMLFormElement} */(document.forms[formName]));
    formElement?.querySelectorAll('input')?.forEach(input => input.addEventListener('input', onChangeProxy));
    formElement?.querySelectorAll('input')?.forEach(input => input.addEventListener('change', onChangeProxy));
    return () => {
      formElement?.querySelectorAll('input')?.forEach(input => input.removeEventListener('input', onChangeProxy));
      formElement?.querySelectorAll('input')?.forEach(input => input.removeEventListener('change', onChangeProxy));
    }
  }, []);

  return <form
    name={formName}
    className={classNames}
    onSubmit={onSubmitProxy}
    autoComplete={noAutocomplete ? 'new-password' : void 0}
    id={formUID}
    hidden={hidden}
    {...(formAttr ?? {})}
  >
    {title ? <Heading level={4} bold asSpan className={classNamesTitle}>{title}</Heading> : null}
    {errors ? <FormError show>{errors}</FormError> : null}
    {icon ? <div className='form-icon'>{icon}</div> : null}
    {children ? <div className={classNamesContent}>{children}</div> : null}
    {buttons ? <div className={classNamesButtons}>{getButtons()}</div> : null}
    {extraFooter ? <div className={classNamesExtraFooter}>{extraFooter}</div> : null}
    <BusyCover isBusy={isBusy} />
  </form >
}

export default From;
